import React from 'react';
import {useTranslation} from 'react-i18next';
import {APP_NAME, MAP_ADDRESS, MAP_IFRAME, WHERE_WE_ARE_INFO} from "../utils/constants";

const WhereWeAre = () => {
    const {t} = useTranslation();
    return (
        <section id="where-we-are" className="py-16 bg-white">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t('whereWeAre.title')}</h2>

                <div className="flex flex-col md:flex-row bg-gray-50 rounded-lg shadow-sm overflow-hidden p-8">
                    {/* Address Information */}
                    <div className="w-full md:w-1/2 p-8">
                        <h3 className="text-2xl font-bold text-gray-900 mb-4">{APP_NAME}</h3>
                        <div className="space-y-4">
                            <div>
                                <h4 className="font-semibold text-lg text-gray-900">{t('whereWeAre.address')}</h4>
                                <p className="text-gray-600">{WHERE_WE_ARE_INFO.address}</p>
                            </div>

                            <div>
                                <h4 className="font-semibold text-lg text-gray-900">{t('whereWeAre.time')}</h4>
                                <p className="text-gray-600">{WHERE_WE_ARE_INFO.time.weekdays}</p>
                                <p className="text-gray-600">{WHERE_WE_ARE_INFO.time.weekend}</p>
                            </div>

                            <div>
                                <h4 className="font-semibold text-lg text-gray-900">{t('whereWeAre.contacts')}</h4>
                                <p className="text-gray-600">{t('whereWeAre.phone')}: {WHERE_WE_ARE_INFO.contacts.phone}</p>
                                <p className="text-gray-600">{t('whereWeAre.email')}: {WHERE_WE_ARE_INFO.contacts.email}</p>
                            </div>

                            <div className="pt-4">
                                <a
                                    href={MAP_ADDRESS}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-pastita-orange text-white px-6 py-2 rounded-lg hover:bg-orange-700 transition-colors font-medium inline-block"
                                >
                                    {t('whereWeAre.navigation')}
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Google Maps */}
                    <div className="w-full md:w-1/2 h-96 md:h-auto">
                        <iframe
                            src={MAP_IFRAME}
                            width="100%"
                            height="100%"
                            style={{border: 0}}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            className="w-full h-full"
                            title={t('whereWeAre.mapTitle')}
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhereWeAre;
